import { render, staticRenderFns } from "./CaptionText.vue?vue&type=template&id=9fe4539c&scoped=true&"
import script from "./CaptionText.vue?vue&type=script&lang=js&"
export * from "./CaptionText.vue?vue&type=script&lang=js&"
import style0 from "./CaptionText.vue?vue&type=style&index=0&id=9fe4539c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe4539c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fe4539c')) {
      api.createRecord('9fe4539c', component.options)
    } else {
      api.reload('9fe4539c', component.options)
    }
    module.hot.accept("./CaptionText.vue?vue&type=template&id=9fe4539c&scoped=true&", function () {
      api.rerender('9fe4539c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/common/common/Text/CaptionText.vue"
export default component.exports